import { createAuthClient } from 'better-auth/react'
import { organizationClient } from 'better-auth/client/plugins'
import { inferAdditionalFields } from 'better-auth/client/plugins'

export const { signIn, signUp, signOut, forgetPassword, resetPassword, useSession } =
  createAuthClient({
    baseURL: import.meta.env.VITE_API_URL,
    basePath: '/v1/auth',
    plugins: [
      organizationClient(),
      inferAdditionalFields({
        user: {
          businessName: {
            type: 'string',
            required: true,
          },
          timezone: {
            type: 'string',
            required: true,
          },
        },
      }),
    ],
  })
